var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvalidApplied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384.1 302.8",
    style: {
      enableBackground: "new 0 0 384.1 302.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CCCCCC;}\r\n\t.st1{fill:none;stroke:#535461;stroke-width:2;}\r\n\t.st2{fill:#017572;}\r\n\t.st3{fill:#93D502;}\r\n\t.st4{fill:#EF1E14;}\r\n\t.st5{display:none;fill:#EF1E14;}\r\n\t.st6{opacity:0.43;fill:#EF1E14;enable-background:new    ;}\r\n\t.st7{opacity:0.17;fill:#EF1E14;enable-background:new    ;}\r\n\t.st8{fill:#F2F2F2;}\r\n\t.st9{fill:#A0616A;}\r\n\t.st10{fill:#0B132B;}\r\n\t.st11{fill:#2F2E41;}\r\n\t.st12{display:none;fill:#E6E6E6;}\r\n\t.st13{display:none;fill:#F2F2F2;}\r\n\t.st14{display:none;fill:#51CB20;}\r\n\t.st15{fill:#FFB6B6;}\r\n\t.st16{display:none;opacity:0.3;fill:#F0F0F0;enable-background:new    ;}\r\n\t.st17{fill:#01A9E0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18449",
    transform: "translate(-735.441 -464.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    className: "st0",
    d: "M995.3,766c-0.3,1-196.5,1-196.8,0C798.8,765,994.9,765,995.3,766z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18447",
    transform: "translate(883.439 709.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    className: "st1",
    d: "M10.5,57.4c0,0,4.3-14.4-0.8-25.1C7.5,27.9,6.9,22.9,7.8,18c0.5-2.3,1.1-4.5,2-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    className: "st2",
    d: "M6.7,3.2c0,1.8,3.2,6.9,3.2,6.9s3.2-5.1,3.2-6.9S11.7,0,9.9,0C8.1,0,6.7,1.4,6.7,3.2L6.7,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "st2",
    d: "M1.4,13.2c1,1.5,6.4,4,6.4,4s-0.1-6-1.1-7.5c-0.9-1.5-2.9-2-4.4-1.1s-2,2.9-1.1,4.4 C1.3,13,1.4,13.1,1.4,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "st2",
    d: "M1.6,30.2c1.6,0.8,7.6,0.2,7.6,0.2s-3.1-5.2-4.7-6c-1.6-0.7-3.5,0-4.2,1.6 C-0.4,27.6,0.2,29.4,1.6,30.2L1.6,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "st3",
    d: "M4.7,43.8c1.4,1.1,7.5,1.5,7.5,1.5s-2.2-5.6-3.6-6.7C7,37.6,5,38,4,39.5 C3.1,40.9,3.4,42.7,4.7,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "st2",
    d: "M14.6,17.6c-1.3,1.2-7.2,2.5-7.2,2.5s1.4-5.9,2.7-7.1c1.2-1.3,3.2-1.3,4.5-0.1s1.3,3.2,0.1,4.5 C14.7,17.5,14.6,17.6,14.6,17.6L14.6,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    className: "st3",
    d: "M17.9,32.7c-1.6,0.8-7.6,0.2-7.6,0.2s3.1-5.2,4.7-6c1.6-0.7,3.5,0,4.2,1.6 C20,30.1,19.4,31.9,17.9,32.7L17.9,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    className: "st2",
    d: "M19.2,48.4c-1.4,1.1-7.5,1.5-7.5,1.5s2.2-5.6,3.6-6.7c1.5-1,3.5-0.6,4.5,0.8 C20.8,45.5,20.5,47.4,19.2,48.4L19.2,48.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18448",
    transform: "translate(932.147 658.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    className: "st1",
    d: "M18.8,108.3c0,0-8-27.2,1.5-47.3c4-8.4,5.3-17.8,3.5-27c-0.9-4.3-2.2-8.6-3.8-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    className: "st2",
    d: "M25.9,6.1c0,3.3-6,13-6,13s-6-9.7-6-13s2.7-6,6.1-6C23.2,0,25.9,2.7,25.9,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    className: "st2",
    d: "M35.8,24.8c-1.8,2.8-12.1,7.6-12.1,7.6s0.2-11.4,2-14.2c1.7-2.9,5.4-3.9,8.3-2.2 s3.9,5.4,2.2,8.3C36.1,24.5,36,24.7,35.8,24.8L35.8,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    className: "st2",
    d: "M35.4,56.9c-3,1.5-14.3,0.5-14.3,0.5S27,47.7,30,46.2c3-1.4,6.6,0,8,3 C39.3,52,38.2,55.4,35.4,56.9L35.4,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    className: "st3",
    d: "M29.7,82.6c-2.7,2-14.1,2.9-14.1,2.9s4.2-10.6,6.9-12.6c2.8-1.9,6.5-1.1,8.4,1.7 C32.6,77.1,32.1,80.6,29.7,82.6L29.7,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    className: "st2",
    d: "M11,33.2c2.4,2.3,13.5,4.7,13.5,4.7s-2.7-11.1-5.1-13.4c-2.3-2.4-6.1-2.6-8.6-0.3 c-2.4,2.3-2.6,6.1-0.3,8.6C10.7,33,10.9,33.1,11,33.2L11,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    className: "st3",
    d: "M4.7,61.7c3,1.5,14.3,0.5,14.3,0.5s-5.9-9.8-8.9-11.3c-3.1-1.3-6.6,0-8,3.1 C0.9,56.8,2,60.2,4.7,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    className: "st2",
    d: "M2.3,91.4c2.7,2,14.1,2.9,14.1,2.9s-4.2-10.6-6.9-12.6c-2.8-1.9-6.5-1.2-8.4,1.6 C-0.7,85.9-0.2,89.4,2.3,91.4L2.3,91.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    className: "st4",
    d: "M915.2,632.6c-26.4,0-47.9-21.4-47.9-47.9s21.4-47.9,47.9-47.9c26.4,0,47.9,21.4,47.9,47.9l0,0 C963.1,611.2,941.6,632.6,915.2,632.6z M915.2,542.4c-23.4,0-42.4,19-42.4,42.4s19,42.4,42.4,42.4s42.4-19,42.4-42.4l0,0 C957.6,561.4,938.6,542.4,915.2,542.4L915.2,542.4L915.2,542.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    className: "st5",
    d: "M907.1,603.3c-0.1,0-0.2,0-0.3,0c-1.7-0.1-3.3-0.9-4.4-2.3l-7.5-9.7c-2-2.6-1.5-6.3,1-8.3 l0.3-0.2c2.6-2,6.3-1.5,8.3,1l0,0c1.5,1.9,4.2,2.2,6,0.8c0.2-0.1,0.3-0.3,0.5-0.4l15.3-16.2c2.2-2.4,6-2.5,8.3-0.2l0.3,0.2 c2.4,2.2,2.5,6,0.2,8.3l0,0l-23.8,25.1C910.3,602.7,908.7,603.3,907.1,603.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    className: "st6",
    d: "M915.2,649.1c-35.5,0-64.4-28.8-64.4-64.3s28.8-64.4,64.3-64.4s64.4,28.8,64.4,64.3l0,0 C979.5,620.3,950.7,649.1,915.2,649.1z M915.2,527.8c-31.5,0-57,25.5-57,57s25.5,57,57,57s57-25.5,57-57l0,0 C972.2,553.3,946.7,527.8,915.2,527.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    className: "st7",
    d: "M915.2,666.6c-45.2,0-81.9-36.7-81.9-81.9s36.7-81.9,81.9-81.9s81.9,36.7,81.9,81.9l0,0 C997.1,630,960.4,666.6,915.2,666.6z M915.2,512.3c-40,0-72.5,32.4-72.5,72.5c0,40,32.4,72.5,72.5,72.5c40,0,72.5-32.4,72.5-72.5 l0,0C987.7,544.7,955.2,512.3,915.2,512.3L915.2,512.3L915.2,512.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18445",
    transform: "translate(735.441 514.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    className: "st8",
    d: "M75.7,240.4c-0.9,0-1.6-0.7-1.7-1.5c0-0.5,0.2-0.9,0.5-1.3l0.1-0.4c-0.9-2.2-3.4-3.3-5.6-2.5 c-1.1,0.4-2,1.3-2.4,2.4c-1.9,4.5-4.4,9.1-3.2,14.1c-8.2-17.3-5.4-38.8,6.7-53.5c3.4-1.8,5.9-5.1,6.7-8.9 c-1.6,0.6-3.7-0.8-2.5-2.5c0.5-0.7,1.1-1.3,1.6-2c-6.3-6.7-13.7,3.8-6.8,12.8c-2.3,2.8-4.2,5.9-5.8,9.1c0.4-3.4-0.1-6.9-1.3-10.1 c-1.2-3-3.6-5.5-5.6-8.1c-1.5-1.9-4.3-2.3-6.3-0.8c-1,0.8-1.6,1.9-1.7,3.1c2.3,0.8,2.6,4.1,0,4.5c0.8,7.6,5.5,14.2,12.3,17.6 c-2.5,7-3.5,14.4-2.8,21.8c-1.2-8.6-10.4-10.7-16.9-14.1c-1.2-0.8-2.7-0.4-3.5,0.8c-0.3,0.5-0.5,1.2-0.4,1.8 c0.9,0.4,1.7,0.8,2.5,1.3c1,0.7,1.3,2,0.6,3.1c-0.4,0.5-1,0.9-1.6,1c3.5,8.1,11.5,13.4,20.3,13.5c0.8,3.6,2,7.1,3.6,10.5h12.8 c0-0.1,0.1-0.3,0.1-0.4c-1.2,0.1-2.4,0-3.6-0.2C75.2,247.5,77.6,245.6,75.7,240.4L75.7,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    className: "st9",
    d: "M107.9,90l-1.4-7.9l20.8-9.4l4.5-7.9c-0.4-2.1,0.9-4.1,3-4.6s4.1,0.9,4.6,3 c0.3,1.6-0.4,3.3-1.9,4.1l-7.4,11.4L107.9,90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    className: "st10",
    d: "M101.6,83.5l9.4-4.8l2.5,9.3l-6.5,4.8L101.6,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    className: "st9",
    d: "M80.6,241.5h5.7l2.7-21.8h-8.3L80.6,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    className: "st11",
    d: "M88.2,242.1v-3.8l-1.5,0.1l-6.1,0.4l-1.4,0.1l-1.1,12.8l-0.1,0.7h4l0.1-0.7l0.6-3.1l1.5,3.1 l0.3,0.7h10.6c1.3,0,2.4-1.1,2.4-2.4C98.1,247.8,89.3,243.3,88.2,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    className: "st9",
    d: "M13.5,155l-1.3,5.5l20.6,7.7l1.9-8.1L13.5,155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    className: "st11",
    d: "M11.7,162.2l3.7,0.9l0.3-1.5l1.1-6l0.2-1.4l-12.2-4L4.1,150l-0.9,3.9l0.6,0.3l2.9,1.3 l-3.4,0.7l-0.7,0.2l-2.5,10.4c-0.3,1.3,0.5,2.6,1.8,2.9C3.8,170.5,10.2,163,11.7,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    className: "st9",
    d: "M89.4,100.4L82.1,97l-14.5,17.6l-8.8,2.2c-1.9-1-4.2-0.2-5.2,1.7c-1,1.9-0.2,4.2,1.7,5.2 c1.5,0.8,3.3,0.5,4.5-0.7l12.9-4.1L89.4,100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    className: "st12",
    d: "M153.6,129.8c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8l0,0 C161.4,126.3,157.9,129.8,153.6,129.8z M153.6,115.1c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9c3.8,0,6.9-3.1,6.9-6.9l0,0 C160.5,118.2,157.4,115.1,153.6,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    className: "st12",
    d: "M153.1,124.9L153.1,124.9c-0.3,0-0.6-0.1-0.8-0.4l-1.2-1.6c-0.3-0.4-0.3-1,0.2-1.3l0,0l0,0 c0.4-0.3,1-0.3,1.4,0.2l0,0c0.2,0.3,0.7,0.4,1,0.1c0,0,0.1,0,0.1-0.1l2.5-2.6c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4l0,0 l-3.9,4.1C153.6,124.8,153.3,124.9,153.1,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    className: "st12",
    d: "M68.1,24.6c-4.3,0-7.8-3.5-7.8-7.8S63.8,9,68.1,9s7.8,3.5,7.8,7.8l0,0 C75.9,21.1,72.4,24.6,68.1,24.6z M68.1,9.9c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9s6.9-3.1,6.9-6.9S71.9,9.9,68.1,9.9L68.1,9.9 L68.1,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    className: "st12",
    d: "M67.6,19.7L67.6,19.7c-0.3,0-0.6-0.1-0.8-0.4l-1.2-1.6c-0.3-0.4-0.3-1,0.2-1.3l0,0l0,0 c0.4-0.3,1-0.3,1.4,0.2l0,0c0.2,0.3,0.7,0.4,1,0.1c0,0,0.1,0,0.1-0.1l2.5-2.6c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4l0,0 l-3.9,4.1C68.1,19.6,67.8,19.7,67.6,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    className: "st13",
    d: "M130.6,158.8c-18.1,0-38.9-20.1-57.3-10.5c-55.7,28.9-48-19.4-64-37.4l0.5-1.1 c17.7,15.8,39.7,28.7,63.8,37.2c21.7,7.7,43.6,11.3,63.3,10.3v1.3C134.8,158.7,132.7,158.8,130.6,158.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2837",
    className: "st12",
    cx: 105.8,
    cy: 18,
    rx: 3.8,
    ry: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    className: "st12",
    d: "M149.4,102.2c-0.7,0.5-1.7,0.3-2.2-0.5c-0.5-0.7-0.3-1.7,0.5-2.2l0,0 c0.7-0.5,1.7-0.3,2.2,0.5C150.4,100.7,150.2,101.7,149.4,102.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2838",
    className: "st14",
    cx: 139.5,
    cy: 4.9,
    rx: 4.9,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2839",
    className: "st13",
    cx: 128.4,
    cy: 126.8,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    className: "st11",
    d: "M82,128.7c0,0-11.9,7.8-8.8,12.9c0.1,0.2-14.3,19.2-14.3,19.2L31.8,159l-1,9.1l24.2,7 c0,0,5.9,4.3,10.5-0.4s19.8-19.4,19.8-19.4l0.7,29.6l-7.6,41l11.4-0.7l11.1-41.1l4.1-46.6L82,128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    className: "st10",
    d: "M90.5,82l-5,3.8L79.8,98l5.5,7.5c0,0,4.6,8-2.8,15.8s-13.1,16.1-7.2,15.8s30,11.9,30.1,1.9 s0.5-17.7,0.5-17.7l6.3-16c0,0,3.8-9.5,1.1-12.4s-6.2-6.5-6.2-6.5l-6.4-6.4H95L90.5,82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    className: "st9",
    d: "M99.9,58.5c11.3,6.4,2,23.3-9.5,17.3C79.2,69.4,88.4,52.5,99.9,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    className: "st11",
    d: "M105.9,62.1c-0.8,1-2.4,0.5-5.7,1.3c0-1.1-0.1-2.2-0.4-3.3c-0.2,1.3-0.8,2.6-1.5,3.7 c-2.8,0.3,0.6,8.8-0.8,15.1c-1.9-13.2-5.7-9.8-3.8-7.1c1.3,1.7,0.4,6.7-3.4,4.2c-6.2,3-15.1-11.7-5.3-18.6c-0.2-3.7,4-4.3,6.5-3.2 C97.9,49.5,105,55.4,105.9,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    className: "st11",
    d: "M77,52.4c-2.5,15.4-16-2.8-22.3,12.3c-2,5.5,1.4,9.4,3.6,14c0.5,3.8-4.4,5.7-4.9,9.1 c-0.1,7.9,12.6,7.4,16.2,2.4c3.7-5.2-0.7-12.2,1.5-17.8c3.1-7.8,15.7-7.8,16.8-16.9C85.8,52.5,80.1,49,77,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    className: "st11",
    d: "M87.2,53.9C87.1,53.9,87,54,87,54l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.1-0.1-0.2-0.2-0.3-0.3 c0,0.1,0,0.3,0,0.4v0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.1-0.1,0.2-0.1C87.2,54.2,87.2,54.1,87.2,53.9 L87.2,53.9z M89.8,49.1c-1.9-0.4-2.5,2.1-2.7,3.3c-0.7-4.4-3.6-3-2.6,0c0.3,0.9,0.8,1.7,1.5,2.4c0.1,0.1,0.2,0.2,0.3,0.3 c-0.1,0.6,0.5,0.4,1.3-0.1c0.6-0.4,1.1-0.9,1.6-1.4C90.7,51.9,91.9,49.7,89.8,49.1L89.8,49.1z M89.8,51.6c-0.6,0.8-1.3,1.5-2,2.1 c-0.2,0.2-0.5,0.4-0.7,0.6v0.1c0,0,0,0.1-0.1,0.1c-0.2,0.4-0.5,0.2-0.6-0.2l0,0c-0.3-0.4-0.6-0.8-0.9-1.2 c-1.8-3.1,1.1-5.2,0.9,0.6c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.3,0,0.4v0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.2-0.1,0.3-0.2 c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.2,0-0.4l0,0c0.1-1.2,0.4-3.2,1-3.8C89.4,49.1,91,50.2,89.8,51.6L89.8,51.6z M87.2,53.9 C87.1,54,87,54,86.9,54l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.1-0.1-0.2-0.2-0.3-0.3c0,0.1,0,0.3,0,0.4v0.1c0.1,0.1,0.2,0.2,0.3,0.3 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.1-0.1,0.2-0.1C87.2,54.2,87.2,54.1,87.2,53.9L87.2,53.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18446",
    transform: "translate(955.253 464.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    className: "st13",
    d: "M159.3,153.4c-14.4,10.9-43.1,7.5-52,26.2c-27,56.7-50,13.5-73.6,8.8l-0.2-1.2 c23.6,2,49-1.1,73.3-8.8c22-7,41.6-17.3,56.7-30l0.8,1C162.7,150.8,161,152.1,159.3,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    className: "st8",
    d: "M54.3,290.3c0.9,0,1.6-0.7,1.7-1.5c0-0.5-0.2-0.9-0.5-1.3l-0.1-0.4c0.9-2.2,3.4-3.3,5.6-2.5 c1.1,0.4,2,1.3,2.4,2.4c1.9,4.5,4.4,9.1,3.2,14.1c8.2-17.3,5.4-38.8-6.7-53.5c-3.4-1.8-5.9-5.1-6.7-8.9c1.6,0.6,3.7-0.8,2.5-2.5 c-0.5-0.7-1.1-1.3-1.6-2c6.3-6.7,13.7,3.8,6.8,12.8c2.3,2.8,4.2,5.9,5.8,9.1c-0.4-3.4,0.1-6.9,1.3-10.1c1.2-3,3.6-5.5,5.6-8.1 c1.5-1.9,4.3-2.3,6.3-0.8c1,0.8,1.6,1.9,1.7,3.1c-2.3,0.8-2.6,4.1,0,4.5c-0.8,7.6-5.5,14.2-12.3,17.6c2.5,7,3.5,14.4,2.8,21.8 c1.2-8.6,10.4-10.7,16.9-14.1c1.2-0.8,2.7-0.4,3.5,0.8c0.3,0.5,0.5,1.2,0.4,1.8c-0.9,0.4-1.7,0.8-2.5,1.3c-1,0.7-1.3,2-0.6,3.1 c0.4,0.5,1,0.9,1.6,1c-3.5,8.1-11.5,13.4-20.3,13.5c-0.8,3.6-2,7.1-3.6,10.5H54.6c0-0.1-0.1-0.3-0.1-0.4c1.2,0.1,2.4,0,3.6-0.2 C54.9,297.4,52.4,295.5,54.3,290.3L54.3,290.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    className: "st15",
    d: "M59,292.2l-5.5,1.3L46,272.7l8.2-1.9L59,292.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    className: "st11",
    d: "M60.5,297.9l-17,3.9v-0.2c-0.8-3.7,1.5-7.3,5.1-8.1l0,0l0,0l2.6-3.1l6.3,1l1.5-0.3 L60.5,297.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    className: "st15",
    d: "M148.3,191.1l3,4.8l-17,14l-4.5-7.1L148.3,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    className: "st11",
    d: "M153.2,187.8l9.4,14.7l-0.2,0.1c-3.2,2-7.4,1.1-9.4-2.1l0,0l0,0l-3.7-1.4l-1.1-6.3l-0.8-1.3 L153.2,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    className: "st12",
    d: "M56.6,85.2c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8l0,0 C64.4,81.8,60.9,85.2,56.6,85.2z M56.6,70.5c-3.8,0-6.9,3.1-6.9,6.9s3.1,6.9,6.9,6.9c3.8,0,6.9-3.1,6.9-6.9l0,0 C63.5,73.6,60.4,70.5,56.6,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    className: "st12",
    d: "M56,80.4L56,80.4c-0.3,0-0.6-0.1-0.8-0.4L54,78.4c-0.3-0.4-0.3-1,0.2-1.3l0,0l0,0 c0.4-0.3,1-0.3,1.4,0.2l0,0c0.2,0.3,0.7,0.4,1,0.1c0,0,0.1,0,0.1-0.1l2.5-2.6c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4l0,0 l-3.9,4.1C56.6,80.3,56.3,80.4,56,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    className: "st16",
    d: "M20.7,81.8L48.7,0L18,80.9c-0.5,0.7-0.4,1.6,0.2,2.2s1.6,0.4,2.2-0.2 C20.6,82.5,20.7,82.2,20.7,81.8L20.7,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    className: "st11",
    d: "M55.3,188.9l-4.2,10.9l-19.5,38.5l17.2,44.8l8.9-2.3l-7.3-42.5l20.9-25.4l24.9,16.9 c0,0,11,8.6,15.2,0.4s31.3-25.5,31.3-25.5l-6.7-7.2l-31.3,14.6l-21.6-30.4L55.3,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    className: "st17",
    d: "M76.3,137.7l-6.9-7.4l-11.8-1.6l-14.4,10.1l0.1,11.2l7.1,26.3c0,0-2.7,18.9,4.9,18.7 s11.7-4,14.8-3.2s16.2,4,17,0.6s5.2-1,5.1-4.2s-12-26.6-12-26.6l2.9-23.4L76.3,137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    className: "st15",
    d: "M119.7,103.8c0.2,2.3-1.5,4.4-3.8,4.6c-0.2,0-0.5,0-0.7,0l-15.8,30l-4.2-6.5l16.1-28.3 c0.3-2.3,2.5-3.9,4.8-3.6C118,100.3,119.5,101.9,119.7,103.8L119.7,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    className: "st17",
    d: "M70.1,143.3c0,0-0.6,5.3,5.4,6.6s22.6-8.2,25.3-9.6c0.9-0.5,2-2.7,3.2-5.5 c0.5-1.3,1.1-2.7,1.6-4.1c0.3-0.8,1.7-1,2-1.9s-0.6-2.2-0.3-3c1.2-3.6,2.1-6.5,2.1-6.5l-4-7.5c-5.6,2.9-8.4,9.4-10.5,16.9 L70.1,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    className: "st15",
    d: "M0.1,110.7c0.4,2.3,2.5,3.9,4.8,3.5c0.2,0,0.5-0.1,0.7-0.2l22.8,25.1l2.5-7.3L8.1,108.4 c-0.9-2.2-3.4-3.2-5.5-2.3C0.8,106.9-0.3,108.8,0.1,110.7L0.1,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    className: "st17",
    d: "M57.9,136.5c0,0,1.9,5-3.5,7.8s-24-2.3-27-3c-0.9-0.2-2.6-2.1-4.5-4.5 c-0.8-1.1-1.7-2.3-2.6-3.6c-0.5-0.7-2-0.6-2.4-1.3s0-2.3-0.4-3c-2.1-3.2-3.6-5.8-3.6-5.8l2-8.2c6.1,1.5,10.5,7,14.4,13.7 L57.9,136.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2840",
    className: "st15",
    cx: 63.9,
    cy: 115.7,
    rx: 11.2,
    ry: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    className: "st11",
    d: "M76.6,109.3c-1.2-1.9-3.3-2.9-5.5-2.7c-0.6-4.1-4.4-7-8.6-6.4c-1.5,0.2-3,0.9-4.1,2 c-0.7-0.5-1.5-0.6-2.3-0.2c-0.7,0.3-1.4,0.9-1.9,1.5c-2.5,3.1-3.1,7.4-1.5,11c-0.3-1,0.7-1.8,1.7-2.1s2,0,2.9-0.1 c1.3-0.2,2.4-0.9,3.6-1.1c1.1-0.1,2.1,0.1,3.1,0.4s2.1,0.5,3.1,0.4c1.1-0.1,2.4,3.9,2.4,6.7c0,0.5,0.1,1.2,0.6,1.3 c0.6,0.1,1-0.7,1.6-1c0.6-0.2,1.2,0.2,1.4,0.7c0.2,0.6,0,1.2-0.4,1.7s-0.8,0.8-1.3,1.1l0.3,0.2c0.5,0.5,1.3,0.6,1.9,0.2 s1-0.9,1.4-1.5c1.2-1.8,2-3.8,2.5-6C78.1,113.4,77.7,111.1,76.6,109.3z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.2,101.6c-2-2-5.3-2-7.4,0l-11.1,11.1l-11.1-11.1c-2-2-5.3-2-7.4,0c-2,2-2,5.3,0,7.4l11.1,11.1l-11.1,11.1 c-2,2-2,5.3,0,7.4c1,1,2.3,1.5,3.7,1.5c1.3,0,2.7-0.5,3.7-1.5l11.1-11.1l11.1,11.1c1,1,2.3,1.5,3.7,1.5c1.3,0,2.7-0.5,3.7-1.5 c2-2,2-5.3,0-7.4l-11.1-11.1l11.1-11.1C199.3,106.9,199.3,103.6,197.2,101.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidApplied);
export default __webpack_public_path__ + "static/media/invalid-applied.1942ceb3a36477cb5ee55ea58edfde3e.svg";
export { ForwardRef as ReactComponent };